export class BannerBuilder {

	buildThin(data) {
		return `
			<div class="col-lg--6-12 col-md-wide--12-12">
				<div class="c-tk-banner u-base-offset-bottom c-tk-banner--${data['color']}">
					<a class="c-tk-banner__link" href="${data['link']}">
						<div class="c-tk-banner__header">
							<span class="icon-svg c-tk-banner__icon" aria-hidden="true">
								<svg class="icon-svg__svg" viewBox="0 0 90 90" width="90" height="90">
								  <use xlink:href="${data['icon']}"></use>
								</svg>
							</span>
						</div>
						<div class="c-tk-banner__content">
							<h3 class="c-tk-banner__title">${data['headline']}</h3>
							<p class="c-tk-banner__paragraph u-text-center">${data['description']}</p>
							` + (data['button'] ? `<span class="c-tk-banner__button c-button c-button--white">${data['button']}</span>` : ``) + `
						</div>
					</a>
				</div>
			</div>`;
	}

	buildWide(data) {
		return `
			<div class="col-lg--12-12">
				<div class="c-tk-banner c-tk-banner--vertical c-tk-banner--outline c-tk-banner--${data['color']} u-base-offset-bottom">
					<a class="c-tk-banner__link" href="${data['link']}">
						<div class="c-tk-banner__header">
							<span class="icon-svg c-tk-banner__icon u-base-offset-right" aria-hidden="true">
								<svg class="icon-svg__svg" viewBox="0 0 60 60" width="60" height="60">
									<use xlink:href="${data['icon']}"></use>
								</svg>
							</span>
						</div>
						<div class="c-tk-banner__content">
							<h3 class="c-tk-banner__title">${data['headline']}</h3>
							<p class="c-tk-banner__paragraph">${data['description']}</p>
						</div>
						` + (data['button'] ? `<span class="c-tk-banner__button c-button c-button--white">${data['button']}</span>` : ``) + `
					</a>
				</div>
			</div>
		`;
	}
}
